/* eslint-disable */
/**
 * DO NOT EDIT THIS FILE
 */
import { KinesisTracker } from '@weberus/client-tracker';
import type { RoomPeople } from '../module/yanolja_standardcode/room-people';
import type { Category } from '../module/yanolja_clientlog_custom_ycm/category';
import type { Tag } from '../module/yanolja_clientlog_custom_ycm/tag';
import { YcmSingleContent } from '../module/yanolja_clientlog_custom_ycm/ycm-single-content';
import type { IconType } from '../module/yanolja_clientlog/icon-type';

/**
 * PageName: EVENT_PAGE
 */
export const EventPagePageLog = {
  EventPageView: {
    /**
     * 동적 이벤트 페이지 - 진입
     * https://screen.yanolja.in/Q4Z3SHww19h8pdRJ
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/misc/common.txtpb#L4}
     * EventPageView
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L12}
     */
    view({ eventName, eventApplied, userEventStatus }: EventPagePageLog.EventPageView.View) {
      return KinesisTracker.view('EVENT_PAGE', {
        clientEventId: 61,
        pageName: 'PAGE_NAME_EVENT_PAGE',
        eventType: 'EVENT_TYPE_VIEW',
        eventName,
        eventApplied,
        userEventStatus,
      });
    },
  },

  ImageObjectName: {
    /**
     * 동적 이벤트 페이지 - 페이지내 이미지 - 노출
     * 어디까지 스크롤 다운하는지 이 노출을 기준으로 추론하려 함. (단,여백용 이미지를 제외)
     *https://screen.yanolja.in/xxfetFeE41kW6Zu9
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/misc/common.txtpb#L13}
     * EventPageImpr
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L23}
     */
    impression({ eventName, imprName, position }: EventPagePageLog.ImageObjectName.Impression) {
      return KinesisTracker.impression('EVENT_PAGE', {
        clientEventId: 62,
        pageName: 'PAGE_NAME_EVENT_PAGE',
        object: 'object_name',
        objectType: 'OBJECT_TYPE_IMAGE',
        eventType: 'EVENT_TYPE_IMPR',
        eventName,
        imprName,
        position,
      });
    },
  },

  FloatingButtonObjectName: {
    /**
     * 동적 이벤트 페이지 - 플로팅 버튼 - 노츨
     * https://screen.yanolja.in/zdcbCc4cnYqPCHJ0
     *플로팅 버튼은 clickable한 것이어서 노출이어도 customjson에 클릭.proto를 가져옴.
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/misc/common.txtpb#L25}
     * EventPageClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L36}
     */
    impression({ eventName, clickName }: EventPagePageLog.FloatingButtonObjectName.Impression) {
      return KinesisTracker.impression('EVENT_PAGE', {
        clientEventId: 63,
        pageName: 'PAGE_NAME_EVENT_PAGE',
        object: 'object_name',
        objectType: 'OBJECT_TYPE_FLOATING_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        eventName,
        clickName,
      });
    },
  },

  ButtonClickName: {
    /**
     * 동적 이벤트 페이지 - 버튼 - 클릭
     * https://screen.yanolja.in/zdcbCc4cnYqPCHJ0
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/misc/common.txtpb#L37}
     * EventPageClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L36}
     */
    click({ eventName, clickName }: EventPagePageLog.ButtonClickName.Click) {
      return KinesisTracker.click('EVENT_PAGE', {
        clientEventId: 64,
        pageName: 'PAGE_NAME_EVENT_PAGE',
        object: clickName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        eventName,
        clickName,
      });
    },
  },

  YcmSingleContent: {
    /**
     * YCM이 생성하는- 이벤트 페이지 - 진입
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/misc/common.txtpb#L209}
     * YcmSingleContent
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/ycm/ycm_content.proto#L9}
     */
    view({ id, target, title, categories, tags, keyword }: EventPagePageLog.YcmSingleContent.View) {
      return KinesisTracker.view('EVENT_PAGE', {
        clientEventId: 648,
        pageName: 'PAGE_NAME_EVENT_PAGE',
        eventType: 'EVENT_TYPE_VIEW',
        id,
        target,
        title,
        categories,
        tags,
        keyword,
      });
    },
  },

  SectionNameButton: {
    /**
     * YCM이 생성하는- 이벤트 페이지- 클릭 - (각 종 버튼)
     * # 이벤트 페이지를 제작하는 입장에서 clickable 하게 만드는 것들.
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/misc/common.txtpb#L217}
     * YcmClickButton
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L96}
     */
    click({ ycmSingleContent, buttonName, sectionName }: EventPagePageLog.SectionNameButton.Click) {
      return KinesisTracker.click('EVENT_PAGE', {
        clientEventId: 649,
        pageName: 'PAGE_NAME_EVENT_PAGE',
        object: 'buttonName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        ycmSingleContent,
        buttonName,
        sectionName,
      });
    },
  },

  SectionNameIcon: {
    /**
     * YCM이 생성하는- 이벤트 페이지 - 클릭 - (각 종 아이콘)
     * # 아이콘으로 뒤로가기 누르기
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/misc/common.txtpb#L229}
     * YcmClickIcon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L102}
     */
    click({ ycmSingleContent, iconName, sectionName }: EventPagePageLog.SectionNameIcon.Click) {
      return KinesisTracker.click('EVENT_PAGE', {
        clientEventId: 650,
        pageName: 'PAGE_NAME_EVENT_PAGE',
        object: 'iconName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_ICON',
        eventType: 'EVENT_TYPE_CLICK',
        ycmSingleContent,
        iconName,
        sectionName,
      });
    },
  },
};

/**
 * 자동생성된 로그 전송 타입
 */
export namespace EventPagePageLog {
  export namespace EventPageView {
    /**
     * https://screen.yanolja.in/Q4Z3SHww19h8pdRJ
     */
    export interface View {
      /*
       * 이벤트 페이지 진입 이벤트 시 남는 정보
       *이벤트 페이지 명. eg. 야놀자의 VIP, GoldClass 7일 체험.
       */
      eventName: string;
      /* 이벤트 응모 여부, 응모했으면 true, 아니면 false*/
      eventApplied?: boolean;
      /*
       * 이벤트에서 사용자 상태값, 이벤트마다 다를 것으로 맞춤형 자료일 것.
       *eg.체험중, 체험종료
       */
      userEventStatus?: string;
    }
  }
  export namespace ImageObjectName {
    /**
     * 어디까지 스크롤 다운하는지 이 노출을 기준으로 추론하려 함. (단,여백용 이미지를 제외)
     *https://screen.yanolja.in/xxfetFeE41kW6Zu9
     */
    export interface Impression {
      /* 이벤트 페이지 노출 이벤트 시 남는 정보*/
      eventName: string;
      /*
       * 노출 정보
       *섹션 정보일 경우 예시 : https://screen.yanolja.in/WJR8k9D6msqRm9IG , 체험신청하기, goldclass전용특가, 유의사항등등
       *플로팅 버튼 일 경우 예시 : https://screen.yanolja.in/b2KNrjFlBoVHvaAE , 체험신청하기
       */
      imprName: string;
      /* 페이지 내 노출된 순서*/
      position: number;
    }
  }
  export namespace FloatingButtonObjectName {
    /**
     * https://screen.yanolja.in/zdcbCc4cnYqPCHJ0
     *플로팅 버튼은 clickable한 것이어서 노출이어도 customjson에 클릭.proto를 가져옴.
     */
    export interface Impression {
      /* 이벤트 페이지 노출 이벤트 시 남는 정보*/
      eventName: string;
      /*
       * 클릭정보
       *https://screen.yanolja.in/zdcbCc4cnYqPCHJ0
       *예시 : 인기숙소 gold특가로 예약하기.
       */
      clickName: string;
    }
  }
  export namespace ButtonClickName {
    /**
     * https://screen.yanolja.in/zdcbCc4cnYqPCHJ0
     */
    export interface Click {
      /* 이벤트 페이지 노출 이벤트 시 남는 정보*/
      eventName: string;
      /*
       * 클릭정보
       *https://screen.yanolja.in/zdcbCc4cnYqPCHJ0
       *예시 : 인기숙소 gold특가로 예약하기.
       */
      clickName: string;
    }
  }
  export namespace YcmSingleContent {
    /**
     */
    export interface View {
      id: string;
      target: string;
      title: string;
      categories?: Category[];
      tags?: Tag[];
      keyword: string;
    }
  }
  export namespace SectionNameButton {
    /**
     * # 이벤트 페이지를 제작하는 입장에서 clickable 하게 만드는 것들.
     */
    export interface Click {
      ycmSingleContent: YcmSingleContent;
      /* 버튼에 적혀 있는 내용. eg.쿠폰다운로드*/
      buttonName: string;
      /* 섹션을 식별하는 이름*/
      sectionName: string;
    }
  }
  export namespace SectionNameIcon {
    /**
     * # 아이콘으로 뒤로가기 누르기
     */
    export interface Click {
      ycmSingleContent: YcmSingleContent;
      /* 클릭하는 아이콘유형*/
      iconName: IconType;
      /* 섹션을 식별하는 이름*/
      sectionName: string;
    }
  }
}

/**
 * PageName: PHONE_CERTIFY
 */
export const PhoneCertifyPageLog = {
  PhoneCertify: {
    /**
     * 회원가입 외 기타 휴대폰 인증 화면 - 진입
     * https://screen.yanolja.in/sZX9eJwm02uVDZ0B
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/misc/common.txtpb#L48}
     * PhoneCertify
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L46}
     */
    view({ requestGroup, clickName }: PhoneCertifyPageLog.PhoneCertify.View) {
      return KinesisTracker.view('PHONE_CERTIFY', {
        clientEventId: 65,
        pageName: 'PAGE_NAME_PHONE_CERTIFY',
        eventType: 'EVENT_TYPE_VIEW',
        requestGroup,
        clickName,
      });
    },
  },

  ButtonClickName: {
    /**
     * 회원가입 외 기타 휴대폰 인증 화면 - (모든) 클릭 - 인증번호 전송/인증하기
     * https://screen.yanolja.in/sZX9eJwm02uVDZ0B
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/misc/common.txtpb#L57}
     * PhoneCertify
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L46}
     */
    click({ requestGroup, clickName }: PhoneCertifyPageLog.ButtonClickName.Click) {
      return KinesisTracker.click('PHONE_CERTIFY', {
        clientEventId: 66,
        pageName: 'PAGE_NAME_PHONE_CERTIFY',
        object: clickName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        requestGroup,
        clickName,
      });
    },
  },
};

/**
 * 자동생성된 로그 전송 타입
 */
export namespace PhoneCertifyPageLog {
  export namespace PhoneCertify {
    /**
     * https://screen.yanolja.in/sZX9eJwm02uVDZ0B
     */
    export interface View {
      /* 휴대폰 인증이 무슨 용도인가? eg)appForeground : 휴대폰 점유를 위한 인증 | pointExchange : 도도포인트 전환을 위한 인증*/
      requestGroup: string;
      /*
       * 클릭정보
       *https://screen.yanolja.in/sZX9eJwm02uVDZ0B
       *예시 : 인증번호발송, 인증하기
       */
      clickName?: string;
    }
  }
  export namespace ButtonClickName {
    /**
     * https://screen.yanolja.in/sZX9eJwm02uVDZ0B
     */
    export interface Click {
      /* 휴대폰 인증이 무슨 용도인가? eg)appForeground : 휴대폰 점유를 위한 인증 | pointExchange : 도도포인트 전환을 위한 인증*/
      requestGroup: string;
      /*
       * 클릭정보
       *https://screen.yanolja.in/sZX9eJwm02uVDZ0B
       *예시 : 인증번호발송, 인증하기
       */
      clickName?: string;
    }
  }
}

/**
 * PageName: WAITING_PAGE
 */
export const WaitingPagePageLog = {
  WaitingPageCommon: {
    /**
     * 대기열 페이지 view
     * 신규 로그
     *화면 : https://screen.yanolja.in/lKZXbMTE2xwTXzWj
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/misc/common.txtpb#L68}
     * WaitingPageCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L56}
     */
    view({ pageStatus }: WaitingPagePageLog.WaitingPageCommon.View) {
      return KinesisTracker.view('WAITING_PAGE', {
        clientEventId: 367,
        pageName: 'PAGE_NAME_WAITING_PAGE',
        eventType: 'EVENT_TYPE_VIEW',
        pageStatus,
      });
    },

    /**
     * 대기열 페이지 resume
     * 신규 로그
     *화면 : https://screen.yanolja.in/lKZXbMTE2xwTXzWj
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/misc/common.txtpb#L78}
     * WaitingPageCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L56}
     */
    resume({ pageStatus }: WaitingPagePageLog.WaitingPageCommon.Resume) {
      return KinesisTracker.resume('WAITING_PAGE', {
        clientEventId: 368,
        pageName: 'PAGE_NAME_WAITING_PAGE',
        eventType: 'EVENT_TYPE_RESUME',
        pageStatus,
      });
    },
  },

  ButtonCloseBtn: {
    /**
     * 대기열 페이지 내 클릭
     * 신규 로그
     *화면 : https://screen.yanolja.in/lKZXbMTE2xwTXzWj
     *########### 모바일 입장권 START ##############
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/misc/common.txtpb#L88}
     * WaitingPageCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L56}
     */
    click({ pageStatus }: WaitingPagePageLog.ButtonCloseBtn.Click) {
      return KinesisTracker.click('WAITING_PAGE', {
        clientEventId: 369,
        pageName: 'PAGE_NAME_WAITING_PAGE',
        object: 'closeBtn',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        pageStatus,
      });
    },
  },
};

/**
 * 자동생성된 로그 전송 타입
 */
export namespace WaitingPagePageLog {
  export namespace WaitingPageCommon {
    /**
     * 신규 로그
     *화면 : https://screen.yanolja.in/lKZXbMTE2xwTXzWj
     */
    export interface View {
      /*
       * page_status = &#39;판매오픈예정&#39; | &#39;대기중&#39;
       *https://screen.yanolja.in/ZS8yhcMKFrerTvyi
       */
      pageStatus: string;
    }

    /**
     * 신규 로그
     *화면 : https://screen.yanolja.in/lKZXbMTE2xwTXzWj
     */
    export interface Resume {
      /*
       * page_status = &#39;판매오픈예정&#39; | &#39;대기중&#39;
       *https://screen.yanolja.in/ZS8yhcMKFrerTvyi
       */
      pageStatus: string;
    }
  }
  export namespace ButtonCloseBtn {
    /**
     * 신규 로그
     *화면 : https://screen.yanolja.in/lKZXbMTE2xwTXzWj
     *########### 모바일 입장권 START ##############
     */
    export interface Click {
      /*
       * page_status = &#39;판매오픈예정&#39; | &#39;대기중&#39;
       *https://screen.yanolja.in/ZS8yhcMKFrerTvyi
       */
      pageStatus: string;
    }
  }
}

/**
 * PageName: MOBILE_TICKET_DETAIL
 */
export const MobileTicketDetailPageLog = {
  LeisureTicketNo: {
    /**
     * 모바일입장권 view
     * 기존 로그 : 로그정의서 옮김
     *화면 : https://screen.yanolja.in/w9tljlY3DdLUikGs
     *레거시
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/misc/common.txtpb#L102}
     * MobileTicketCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L62}
     */
    view({ voucherNumberList, leisureTicketNo }: MobileTicketDetailPageLog.LeisureTicketNo.View) {
      return KinesisTracker.view('MOBILE_TICKET_DETAIL', {
        clientEventId: 521,
        pageName: 'PAGE_NAME_MOBILE_TICKET_DETAIL',
        object: leisureTicketNo,
        objectType: 'OBJECT_TYPE_LEISURE_TICKET_NO',
        eventType: 'EVENT_TYPE_VIEW',
        voucherNumberList,
        leisureTicketNo,
      });
    },
  },

  ButtonShareBtn: {
    /**
     * 모바일입장권 공유하기 버튼 클릭
     * 신규 로그
     *화면 : https://screen.yanolja.in/sFDTxNwrTFXW4WfU
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/misc/common.txtpb#L114}
     * MobileTicketCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L62}
     */
    click({ voucherNumberList, leisureTicketNo }: MobileTicketDetailPageLog.ButtonShareBtn.Click) {
      return KinesisTracker.click('MOBILE_TICKET_DETAIL', {
        clientEventId: 522,
        pageName: 'PAGE_NAME_MOBILE_TICKET_DETAIL',
        object: 'shareBtn',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        voucherNumberList,
        leisureTicketNo,
      });
    },
  },

  ButtonShareChannelBtn: {
    /**
     * 모바일입장권 공유하기 > 공유 채널 선택 클릭
     * 신규 로그
     *화면 : https://screen.yanolja.in/gfrYZN0pnN9oV4ez
     *########### 모바일 입장권 END ##############
     *#### <기획전> 날짜 및 인원 선택 bottom sheet 시작 #####
     *## 국내 / 해외 동일한 로그 ###
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/misc/common.txtpb#L127}
     * MobileTicketShare
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L67}
     */
    click({ voucherNumberList, leisureTicketNo, shareChannel }: MobileTicketDetailPageLog.ButtonShareChannelBtn.Click) {
      return KinesisTracker.click('MOBILE_TICKET_DETAIL', {
        clientEventId: 523,
        pageName: 'PAGE_NAME_MOBILE_TICKET_DETAIL',
        object: 'shareChannelBtn',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        voucherNumberList,
        leisureTicketNo,
        shareChannel,
      });
    },
  },
};

/**
 * 자동생성된 로그 전송 타입
 */
export namespace MobileTicketDetailPageLog {
  export namespace LeisureTicketNo {
    /**
     * 기존 로그 : 로그정의서 옮김
     *화면 : https://screen.yanolja.in/w9tljlY3DdLUikGs
     *레거시
     */
    export interface View {
      voucherNumberList?: string[];
      leisureTicketNo: string;
    }
  }
  export namespace ButtonShareBtn {
    /**
     * 신규 로그
     *화면 : https://screen.yanolja.in/sFDTxNwrTFXW4WfU
     */
    export interface Click {
      voucherNumberList?: string[];
      leisureTicketNo: string;
    }
  }
  export namespace ButtonShareChannelBtn {
    /**
     * 신규 로그
     *화면 : https://screen.yanolja.in/gfrYZN0pnN9oV4ez
     *########### 모바일 입장권 END ##############
     *#### <기획전> 날짜 및 인원 선택 bottom sheet 시작 #####
     *## 국내 / 해외 동일한 로그 ###
     */
    export interface Click {
      voucherNumberList?: string[];
      leisureTicketNo: string;
      /* 채널 정보 ex ) sms | kakaotalk | linkcopy | facebook*/
      shareChannel: string;
    }
  }
}

/**
 * PageName: EXHIBITION
 */
export const ExhibitionPageLog = {
  CheckInOutDateAndSetPeopleButton: {
    /**
     * 기획전 - bottom sheet 내에서 체크인아웃 날짜 클릭
     * https://screen.yanolja.in/maUkB6hUdVwzGf6w.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/misc/common.txtpb#L145}
     */
    click({}: ExhibitionPageLog.CheckInOutDateAndSetPeopleButton.Click = {}) {
      return KinesisTracker.click('EXHIBITION', {
        clientEventId: 545,
        pageName: 'PAGE_NAME_EXHIBITION',
        object: 'checkInOutDate',
        objectContainer: 'checkInOutDateAndSetPeople',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      });
    },
  },

  CheckInOutDateAndSetPeopleButton546: {
    /**
     * 기획전 - bottom sheet 내에서 인원 변경 클릭
     * https://screen.yanolja.in/Tj1unrmf5bJs36lU.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/misc/common.txtpb#L156}
     */
    click({}: ExhibitionPageLog.CheckInOutDateAndSetPeopleButton546.Click = {}) {
      return KinesisTracker.click('EXHIBITION', {
        clientEventId: 546,
        pageName: 'PAGE_NAME_EXHIBITION',
        object: 'setPeople',
        objectContainer: 'checkInOutDateAndSetPeople',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      });
    },
  },

  CheckInOutDateAndSetPeopleLabelChange: {
    /**
     * 기획전 -  날짜 변경 완료 (설정 후 확인 클릭 시, 변경된 날짜 로깅)
     * https://screen.yanolja.in/FERmFZRzGq3j7CZh.png
     *실제 로그상에는 값이 없음(추가하지 않아도됨). proto 정의시 필수라 추가함
     *#### 날짜 및 인원 선택 bottom sheet 끝 #####
     *#### NOL머니 관련 #####
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/misc/common.txtpb#L167}
     * CheckInOutDateAndSetPeopleClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L73}
     */
    bg({
      checkInDate,
      checkOutDate,
      roomPeople,
      exbusClass,
    }: ExhibitionPageLog.CheckInOutDateAndSetPeopleLabelChange.Bg) {
      return KinesisTracker.bg('EXHIBITION', {
        clientEventId: 547,
        pageName: 'PAGE_NAME_EXHIBITION',
        object: 'changeCheckInOutDate',
        objectContainer: 'checkInOutDateAndSetPeople',
        objectType: 'OBJECT_TYPE_LABEL',
        eventType: 'EVENT_TYPE_BG',
        checkInDate,
        checkOutDate,
        roomPeople,
        exbusClass,
      });
    },
  },
};

/**
 * 자동생성된 로그 전송 타입
 */
export namespace ExhibitionPageLog {
  export namespace CheckInOutDateAndSetPeopleButton {
    /**
     * https://screen.yanolja.in/maUkB6hUdVwzGf6w.png
     */
    export interface Click {}
  }
  export namespace CheckInOutDateAndSetPeopleButton546 {
    /**
     * https://screen.yanolja.in/Tj1unrmf5bJs36lU.png
     */
    export interface Click {}
  }
  export namespace CheckInOutDateAndSetPeopleLabelChange {
    /**
     * https://screen.yanolja.in/FERmFZRzGq3j7CZh.png
     *실제 로그상에는 값이 없음(추가하지 않아도됨). proto 정의시 필수라 추가함
     *#### 날짜 및 인원 선택 bottom sheet 끝 #####
     *#### NOL머니 관련 #####
     */
    export interface Bg {
      /* 바텀싯관련 정보 - &lt;날짜 변경 완료 bg 로그&gt; 에만 추가*/
      checkInDate?: string;
      /* 설정된 체크아웃 날짜*/
      checkOutDate?: string;
      /* 객실 정보.*/
      roomPeople?: RoomPeople[];
      /* 버스 등급 ex) 전체, 프리미엄, 우등, 일반... 심야프리미엄... 등*/
      exbusClass?: string;
    }
  }
}

/**
 * PageName: NOLMONEY_REGISTER
 */
export const NolmoneyRegisterPageLog = {
  PageTitleButtonClickName: {
    /**
     * NOL머니 계좌 인증 버튼 클릭
     * 계좌 인증하기 : https://screen.yanolja.in/ND8XEHHxTZHSxJyO
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/misc/common.txtpb#L185}
     * NolMoneyCertifyClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L82}
     */
    click({ pageTitle, clickName }: NolmoneyRegisterPageLog.PageTitleButtonClickName.Click) {
      return KinesisTracker.click('NOLMONEY_REGISTER', {
        clientEventId: 643,
        pageName: 'PAGE_NAME_NOLMONEY_REGISTER',
        object: 'clickName',
        objectContainer: 'pageTitle',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        pageTitle,
        clickName,
      });
    },
  },

  NolMoneyCertifyView: {
    /**
     * NOL머니 가입 등록 화면(계좌번호 입력, 1원 인증 등) view
     * 계좌번호 입력 https://screen.yanolja.in/m7rq2w6r1jZPF3mp
     *1원 인증 https://screen.yanolja.in/1KAsCt8h9hKR8MQL
     *ARS 전화 인증 https://screen.yanolja.in/X62fraaM68Szu3To
     *비밀번호 등록 화면 https://screen.yanolja.in/xZW82hFPd6JTKGva
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/misc/common.txtpb#L197}
     * NolMoneyCertifyView
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L88}
     */
    view({ pageTitle }: NolmoneyRegisterPageLog.NolMoneyCertifyView.View) {
      return KinesisTracker.view('NOLMONEY_REGISTER', {
        clientEventId: 644,
        pageName: 'PAGE_NAME_NOLMONEY_REGISTER',
        eventType: 'EVENT_TYPE_VIEW',
        pageTitle,
      });
    },
  },
};

/**
 * 자동생성된 로그 전송 타입
 */
export namespace NolmoneyRegisterPageLog {
  export namespace PageTitleButtonClickName {
    /**
     * 계좌 인증하기 : https://screen.yanolja.in/ND8XEHHxTZHSxJyO
     */
    export interface Click {
      /* 계좌번호 입력 클릭 https://screen.yanolja.in/ND8XEHHxTZHSxJyO*/
      pageTitle: string;
      clickName: string;
    }
  }
  export namespace NolMoneyCertifyView {
    /**
     * 계좌번호 입력 https://screen.yanolja.in/m7rq2w6r1jZPF3mp
     *1원 인증 https://screen.yanolja.in/1KAsCt8h9hKR8MQL
     *ARS 전화 인증 https://screen.yanolja.in/X62fraaM68Szu3To
     *비밀번호 등록 화면 https://screen.yanolja.in/xZW82hFPd6JTKGva
     */
    export interface View {
      /*
       * 계좌번호 입력 https://screen.yanolja.in/m7rq2w6r1jZPF3mp
       *1원 인증 https://screen.yanolja.in/1KAsCt8h9hKR8MQL
       *ARS 전화 인증 https://screen.yanolja.in/X62fraaM68Szu3To
       *비밀번호 등록 화면 https://screen.yanolja.in/xZW82hFPd6JTKGva
       */
      pageTitle: string;
    }
  }
}

/**
 * PageName: PROMO_BANNER_ROUNDED_LIST
 */
export const PromoBannerRoundedListPageLog = {
  PromotionTallBannerSwipe: {
    /**
     * 프로모션 배너 리스트 화면(=홈에서 프로모션 전체보기 클릭시) - 진입
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/misc/common.txtpb#L241}
     */
    view({}: PromoBannerRoundedListPageLog.PromotionTallBannerSwipe.View = {}) {
      return KinesisTracker.view('PROMO_BANNER_ROUNDED_LIST', {
        inactive: false,
        clientEventId: 691,
        pageName: 'PAGE_NAME_PROMO_BANNER_ROUNDED_LIST',
        objectContainer: 'promotionTallBannerSwipe',
        eventType: 'EVENT_TYPE_VIEW',
      });
    },
  },

  PromotionTallBannerSwipeId: {
    /**
     * 프로모션 배너 리스트 화면(=홈에서 프로모션 전체보기 클릭시) - 노출 - 프로모션 세로형 배너 위젯 내 - 배너 아이템
     * # 참조하는 SQL: https://screen.yanolja.in/If4fUoYc1WJ8jWBt
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/misc/common.txtpb#L251}
     * PromotionTallBannerSwipeV2Banner
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/widget/promotion_tall_banner_swipe_v2.proto#L19}
     */
    impression({
      widgetTargetTitle,
      widgetId,
      widgetPosition,
      deepLinkUri,
      bannerId,
      position,
    }: PromoBannerRoundedListPageLog.PromotionTallBannerSwipeId.Impression) {
      return KinesisTracker.impression('PROMO_BANNER_ROUNDED_LIST', {
        inactive: false,
        clientEventId: 675,
        pageName: 'PAGE_NAME_PROMO_BANNER_ROUNDED_LIST',
        object: 'bannerId',
        objectContainer: 'promotionTallBannerSwipe',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_IMPR',
        widgetTargetTitle,
        widgetId,
        widgetPosition,
        deepLinkUri,
        bannerId,
        position,
      });
    },

    /**
     * 프로모션 배너 리스트 화면(=홈에서 프로모션 전체보기 클릭시) - 클릭 - 프로모션 세로형 배너 위젯 내 -  배너 아이템
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/misc/common.txtpb#L264}
     * PromotionTallBannerSwipeV2Banner
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/widget/promotion_tall_banner_swipe_v2.proto#L19}
     */
    click({
      widgetTargetTitle,
      widgetId,
      widgetPosition,
      deepLinkUri,
      bannerId,
      position,
    }: PromoBannerRoundedListPageLog.PromotionTallBannerSwipeId.Click) {
      return KinesisTracker.click('PROMO_BANNER_ROUNDED_LIST', {
        inactive: false,
        clientEventId: 676,
        pageName: 'PAGE_NAME_PROMO_BANNER_ROUNDED_LIST',
        object: 'bannerId',
        objectContainer: 'promotionTallBannerSwipe',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_CLICK',
        widgetTargetTitle,
        widgetId,
        widgetPosition,
        deepLinkUri,
        bannerId,
        position,
      });
    },
  },
};

/**
 * 자동생성된 로그 전송 타입
 */
export namespace PromoBannerRoundedListPageLog {
  export namespace PromotionTallBannerSwipe {
    /**
     */
    export interface View {}
  }
  export namespace PromotionTallBannerSwipeId {
    /**
     * # 참조하는 SQL: https://screen.yanolja.in/If4fUoYc1WJ8jWBt
     */
    export interface Impression {
      /* YDM target명 e.g. HOME*/
      widgetTargetTitle: string;
      /* YDM widget ID*/
      widgetId: string;
      /* 홈 오더링 위치. 1부터 시작*/
      widgetPosition: number;
      /* 클릭시 딥링크. 웹이면 웹링크, 앱이면 딥링크 제공*/
      deepLinkUri: string;
      /* YDM widget banner 개별 ID*/
      bannerId: string;
      /* Widget 내 배너 위치. 1부터 시작*/
      position: number;
    }

    /**
     */
    export interface Click {
      /* YDM target명 e.g. HOME*/
      widgetTargetTitle: string;
      /* YDM widget ID*/
      widgetId: string;
      /* 홈 오더링 위치. 1부터 시작*/
      widgetPosition: number;
      /* 클릭시 딥링크. 웹이면 웹링크, 앱이면 딥링크 제공*/
      deepLinkUri: string;
      /* YDM widget banner 개별 ID*/
      bannerId: string;
      /* Widget 내 배너 위치. 1부터 시작*/
      position: number;
    }
  }
}
